import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Verifying your email...");

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      setStatus("Invalid verification link.");
      return;
    }

    api
      .get(`/auth/verify?token=${token}`)
      .then(() => {
        setStatus("✅ Email verified successfully!");
        setTimeout(() => navigate("/login"), 2000);
      })
      .catch((err) => {
        console.error(err);
        setStatus("❌ Verification failed or token expired.");
      });
  }, []);

  return (
    <div style={{ padding: "40px", color: "#00F0FF" }}>
      <h2>Email Verification</h2>
      <p>{status}</p>
    </div>
  );
}

